// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"166":"ProductPinnedContentSpot","197":"ProTipsCarousel","219":"CertonaRecommendation","237":"PiqProduct","361":"ConversationalFilter","437":"SEOData","495":"PromoteIQ","623":"Banner","980":"GoogleAdContainer"}[chunkId] || chunkId) + ".bundle.js";
};